import React from 'react';
import CameraShotsControls from "./CameraShotsControls";
import FeatureChangeControls from "./FeatureChangeControls";

const SectionControls = () => {
  
  return (
    <>
      {/* <FeatureChangeControls/> */}
      {/* <CameraShotsControls/> */}
    </>
  )
};

export default SectionControls;
